function NumberWithDot(num) {

  // Unbelivable! Using this regexp old devices and iPhone does show blank screen!!!
  // return num .toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default NumberWithDot;